<template>
  <vs-row vs-type="flex" vs-w="12">
    <vs-row vs-type="flex" vs-w="12" id="dashBoardTMobileTableOptions"
            class="py-2 mb-2 sale-box-shadow low-border-radius bg-white"
            vs-justify="center">
      <vs-col vs-type="flex" :vs-w="tableOptionsSizes[0]"
              :class="{'border-right' : tableOptionsSizes[0] != 12, 'border-bottom' : tableOptionsSizes[0] == 12}"
              class="border-divider" vs-justify="center" vs-align="center"
              id="dashBoardTableOptionsDate">
        <v-select class="w-full weight-600" :clearable="false" itemid="id" label="dName"
                  v-model="tableOptions.defaultTimeRange" :options="dataSet.timeRanges"/>
      </vs-col>
      <vs-col vs-type="flex" :vs-w="tableOptionsSizes[1]" vs-justify="center" vs-align="center"
              id="dashBoardTableOptionsProp">
        <v-select class="w-full weight-600" :clearable="false"
                  itemid="id" label="dName" v-model="tableOptions.reportByProp" :options="dataSet.reportProps"/>
      </vs-col>
      <vs-col v-if="$isCenterBranch()" vs-type="flex" :vs-w="tableOptionsSizes[2]"
              :class="{'border-left' : tableOptionsSizes[0] != 12, 'border-top' : tableOptionsSizes[0] == 12}"
              class="border-divider"
              vs-justify="center" vs-align="center" id="dashBoardTableOptionsType">
        <v-select class="w-full weight-600" @input="onBranchSelection" :clearable="false" placeholder="Şube Seçimi"
                  itemid="id" label="name" v-model="tableOptions.branch" :options="dataSet.branches"/>
      </vs-col>
    </vs-row>
    <vs-row id="dashboardMobileSlider" vs-type="flex" vs-w="12">
      <swiper :options="swiperOption">
        <swiper-slide>
          <vs-row vs-type="flex" vs-w="12">
            <branch-or-personal-giro-min :stop="false" :isBranchesOrPersonal="dataSet.isBranchOrPersonal"
                                         :branchGiros="dataSet.byBranch.branchGiros"
                                         :payments="dataSet.byBranch.payments"
                                         :personalGiros="dataSet.byBranch.personalGiros"
                                         :totalsOfSales="dataSet.byBranch.totalsOfSales"
                                         :selectedTimeRange="getSelectedTimeRange.dName ? getSelectedTimeRange.dName : ''"
                                         :orderBy="tableOptions.reportByProp ? tableOptions.reportByProp.id : 0"/>
          </vs-row>
        </swiper-slide>
        <swiper-slide>
          <vs-row vs-type="flex" vs-w="12" class="px-1">
            <product-giro-min :table-options="tableOptions" :stop="false" :reportData="dataSet.byProduct"
                              :orderBy="tableOptions.reportByProp ? tableOptions.reportByProp.id : 0"/>
          </vs-row>
        </swiper-slide>
        <swiper-slide>
          <vs-row vs-type="flex" vs-w="12" class="px-1">
            <category-giro-min :table-options="tableOptions" :stop="false" :reportData="dataSet.byCategory"
                               :orderBy="tableOptions.reportByProp ? tableOptions.reportByProp.id : 0"/>
          </vs-row>
        </swiper-slide>
        <swiper-slide>
          <vs-row vs-type="flex" vs-w="12" class="py-1">
            <giro-by-time-min :stop="false" :reportData="dataSet.byHour"
                              :selectedTimeRange="getSelectedTimeRange.dName ? getSelectedTimeRange.dName : ''"/>
          </vs-row>
        </swiper-slide>
        <swiper-slide>
          <vs-row vs-type="flex" vs-w="12" class="py-1">
            <giro-by-date-min :stop="false" :reportData="dataSet.byDate"
                              :selectedTimeRange="getSelectedTimeRange.dName ? getSelectedTimeRange.dName : ''"/>
          </vs-row>
        </swiper-slide>
        <swiper-slide>
          <vs-row vs-type="flex" vs-w="12" class="px-1">
            <target-report :reportData="dataSet.targets"
                           :selectedBranch="tableOptions.branch ? tableOptions.branch : $currentUser.branch"/>
          </vs-row>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </vs-row>
  </vs-row>
</template>

<script>
import StockOrderReport from "./StockOrderReport.vue";
import TargetReport from "./TargetReport.vue";
import GiroByTimeMin from "../Reports/GiroByTime/GiroByTimeMin.vue";
import GiroByDateMin from "../Reports/GiroByDate/GiroByDateMin.vue";
import ProductGiroMin from "../Reports/ProductGiro/ProductGiroMin.vue";
import CategoryGiroMin from "../Reports/CategoryGiro/CategoryGiroMin.vue";
import BranchOrPersonalGiroMin from "../Reports/BranchOrPersonalGiro/BranchOrPersonalGiroMin.vue";
import 'swiper/dist/css/swiper.min.css';
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper';

export default {
  data() {
    return {
      tableOptions: {},
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
    }
  },
  props: {
    dataSet: {
      required: true,
      type: Object
    },
    windowsSize: {
      required: true,
      type: Number
    }
  },
  components: {
    swiper,
    swiperSlide,
    TargetReport,
    BranchOrPersonalGiroMin,
    CategoryGiroMin,
    ProductGiroMin,
    GiroByTimeMin,
    GiroByDateMin,
    StockOrderReport
  },
  computed: {
    tableOptionsSizes() {
      if (this.windowsSize > 550) {
        if (this.$isCenterBranch()) {
          return [5, 3.5, 3.5];
        } else {
          return [6, 6]
        }
      } else {
        if (this.$isCenterBranch()) {
          return [12, 12, 12]
        } else {
          return [12, 12]
        }
      }
    },
    getSelectedTimeRange() {
      if (!this.tableOptions.defaultTimeRange) return {};
      return this.dataSet.timeRanges.find(x => x.id == this.tableOptions.defaultTimeRange.id);
    },
    isTargetShow() {
      if (!this.tableOptions.branch) return false;
      return this.$isCenterBranch() && this.tableOptions.branch && this.tableOptions.branch.id > this.$centerBranchId && this.dataSet
        .targets;
    }
  },
  methods: {
    clearFilter() {
      let nowHour = new Date(Date.now()).getHours()
      this.tableOptions = {
        branch: {
          id:null,
          name:"Tüm Şubeler"
        },
        defaultTimeRange: nowHour >= 0 && nowHour <= 2 ? {
          name: "Yesterday",
          id: 0,
          dName: "Dün"
        } : {
          name: "Today",
          id: 1,
          dName: "Bugün"
        },
        reportByProp: {
          name: "Amount",
          id: 0,
          dName: "Ciroya Göre"
        },
        takeCount:10,
        category: null
      };
    },
    openStockOrderPage() {
      this.$refs.stockOrderPage.isActive = true;
    },
    onBranchSelection(val) {
      this.$emit("branchChanged", val)
    },
    isSelectedProp(prop) {
      if (!this.tableOptions.reportByProp || !prop) return false;
      if (prop.id == this.tableOptions.reportByProp.id) return true;
      return false;
    },
    isSelectedRange(range) {
      if (!this.tableOptions.defaultTimeRange || !range) return false;
      if (range.id == this.tableOptions.defaultTimeRange.id) return true;
      return false;
    },
  },
  mounted() {
    this.clearFilter();
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.$emit("fetchData", this.tableOptions);
        });
      }
    },
  }
}

</script>

<style>
#dashBoardTMobileTableOptions .vs__dropdown-toggle {
  border: none !important;
}

#dashBoardTMobileTableOptions .vs__selected {
  white-space: nowrap;
  overflow: hidden;
  max-width: 96%;
  text-overflow: ellipsis;
  display: block;
}

#dashBoardTMobileTableOptions .v-select .vs__dropdown-toggle {
  display: -webkit-box !important;
}

#dashBoardTMobileTableOptions .vs-con-input .vs-inputx {
  padding: 0.5rem 0.4rem !important;
}

#dashBoardTMobileTableOptions .vs__search {
  width: 0;
  padding: 0;
  margin-bottom: 4px;
}
</style>
